module.exports = __webpack_public_path__ + "img/styles-dark.c000b3ab.png";